/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stopwatch'
export default icon
